// Lead capture — stores contact sales submissions in Firestore
//
// Schema:
//   /leads/{leadId}  — one doc per submission

import {
  collection,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { firestoreDb } from '../config/firebase';

const db = firestoreDb;

export async function submitLead({ name, email, company, deptSize, useCase, phone = '' }, source = 'enroll_page') {
  if (!db) throw new Error('Firebase not configured');
  await addDoc(collection(db, 'leads'), {
    name,
    email:    email.toLowerCase(),
    company,
    deptSize,
    useCase,
    phone:    phone || '',
    status:   'new',       // 'new' | 'contacted' | 'qualified' | 'closed'
    source,
    createdAt: serverTimestamp(),
  });
}
